<template>
    <div class="modal-content">
        <h3 class="stack-m"><slot/></h3>
        <div class="grid-content">
            <p v-if="!hasPlaceholders" class="grid-item grid-item-full">
                No placeholders defined for this type
            </p>
            <div v-else class="grid-item grid-item-full" v-for="(placeholder, i) in placeholders" :key="i">
                <r-input
                        :label="placeholder.label"
                        :value="placeholder.value"
                        @input="value => updatePlaceholder(placeholder.token, value)"/>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'preview-webhook-placeholders',
        props: {
            hasPlaceholders: {
                type: Boolean,
                required: true,
            },
            placeholders: Array,
        },
        data() {
            return {};
        },
        methods: {
            updatePlaceholder(token, value) {
                this.$emit('input', {token, value});
            },
        },
    };
</script>
